import { yieldVaultContractConfig } from "@config/contractsConfig";
import useDappConfig from "@hooks/useDappConfig";
import useVaultClaims from "../hooks/useVaultClaims";
import gainVaultJson from "@abi/vault/gain.json";

/**
 * Hook for hgETH (High Growth Vault) claims
 * Uses the yield vault contract and configuration
 */
const useHgEthClaims = () => {
  const { yieldVaultEnabledChains } = useDappConfig();

  return useVaultClaims({
    contractConfig: yieldVaultContractConfig,
    abi: gainVaultJson,
    enabledChains: yieldVaultEnabledChains,
    pathPatterns: ["/growth-vault", "/gain/hgeth"],
  });
};

export default useHgEthClaims;
